<template>
  <!-- the "Spent time" popup of a task card: who tracked it and how long; a click makes that person the executor -->
  <div class="spent-time px-4 py-1.5">
    <div class="dropdown-head-text mb-4 text-text-muted">{{ $t('task.spent_time') }}</div>
    <div class="dropdown-wrapper flex items-center mt-1.5" v-for="ttbu in spentTimes" :key="`${ttbu.id}`">
      <div
        class="item-ttbu flex items-center h-8 pr-1.5 rounded-full cursor-pointer"
        :class="ttbu.ttbuObj.trackingOnline
          ? 'bg-accent-soft text-accent'
          : 'bg-input text-text-soft hover:bg-hover'"
        @click="updateExecutor(ttbu)"
      >
        <UserAvatar
          noBorder
          :active="ttbu.ttbuObj.trackingOnline"
          :withStar="ttbu.userId === task.executorId"
          class="user-avatar size-6.5! ml-px [&_.content]:text-label"
          :class="`avatar-size_${ttbu.sizeImage}`"
          :user="getUser(ttbu.userId)"
        />
        <IntervalHolder
          class="w-15 justify-center text-label font-bold"
          :isActive="ttbu.ttbuObj.timeSlots.length ? ttbu.ttbuObj.trackingOnline : false"
          :ttbu="ttbu.ttbuObj"
        />
      </div>
      <div
        v-if="ttbu.manualTimeTotalSeconds"
        class="item-ttbu__manual flex items-center gap-1 ml-1.5 text-label text-text-muted"
      >
        <i class="tr tr-manual-time h-3"></i>{{ ttbu.manualTimePercent }}%
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import IntervalHolder from '@/components/elements/IntervalHolder';

const props = defineProps({
  task: Object,
  // from useTaskSpentTimes: people who tracked the task, most tracked first
  spentTimes: Array,
});

const store = useStore();

const getUser = computed(() => store.getters['user/getUser']);

const updateExecutor = (ttbu) => {
  store.dispatch('project/actionUpdateTask', {
    id: props.task.id,
    stageId: props.task.stageId,
    projectId: props.task.projectId,
    executorId: ttbu.userId,
  });
};
</script>
